import React from 'react';
import Sticky from 'react-stickynode';
import styled from 'styled-components';
//
const ContentContainerStyled = styled.div`
  @media (min-width: 768px) {
    display: grid;
    grid-gap: 1vw;
    grid-template-areas: 'side main';
    grid-template-columns: 1fr 4fr;
  }
`;

export const ContentContainer = (props) => (
  <ContentContainerStyled>{props.children}</ContentContainerStyled>
);

const ContentSideStyled = styled.div`
  align-self: start;
  grid-area: side;
  padding: 1vw 0;
  width: 100%;
`;

export const ContentSide = (props) => (
  <ContentSideStyled>
    <Sticky>{props.children}</Sticky>
  </ContentSideStyled>
);

export const ContentMain = styled.div`
  align-self: start;
  grid-area: main;
  padding: 0 0 1vw;
  max-width: 100%;
`;

export default ContentContainer;
